import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { useLanguage } from '../../context/LanguageContext';

export function UserCreateDialog({ open, onOpenChange, formData, setFormData, onSubmit }) {
  const { t } = useLanguage();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('admin_users_create')}</DialogTitle>
          <DialogDescription>{t('admin_users_create_desc')}</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div className="space-y-2">
            <Label>{t('name')} *</Label>
            <Input value={formData.full_name} onChange={(e) => setFormData({...formData, full_name: e.target.value})} placeholder={t('register_name_placeholder')} data-testid="create-fullname-input" />
          </div>
          <div className="space-y-2">
            <Label>{t('email')} *</Label>
            <Input type="email" value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})} placeholder="user@example.com" data-testid="create-email-input" />
          </div>
          <div className="space-y-2">
            <Label>{t('password')} *</Label>
            <Input type="password" value={formData.password} onChange={(e) => setFormData({...formData, password: e.target.value})} data-testid="create-password-input" />
          </div>
          <div className="space-y-2">
            <Label>{t('phone')}</Label>
            <Input value={formData.phone} onChange={(e) => setFormData({...formData, phone: e.target.value})} placeholder="090-1234-5678" data-testid="create-phone-input" />
          </div>
          <div className="space-y-2">
            <Label>{t('admin_users_role')}</Label>
            <Select value={formData.role} onValueChange={(value) => setFormData({...formData, role: value})}>
              <SelectTrigger data-testid="create-role-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="user">{t('admin_users_role_user')}</SelectItem>
                <SelectItem value="admin">{t('admin_users_role_admin')}</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label>{t('balance')} (JPY)</Label>
            <Input type="number" value={formData.balance} onChange={(e) => setFormData({...formData, balance: parseFloat(e.target.value) || 0})} placeholder="0" data-testid="create-balance-input" />
          </div>
          <Button className="w-full" onClick={onSubmit} data-testid="submit-create-user-button">{t('admin_users_create')}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
